import { Injectable } from '@angular/core';
import { GeneralApiService, StatusApi } from '@global-service/api';
import { StorageService, ValorPermiso } from '@global-service/storage';


type IConfiguracionesNameType = 'comerciaActivo' | 'sociedades' | 'entidadesSistemaSalud' | 'crossSelling' | 'AccesoCopiaSeguridad';
type IConfiguracionesType = {[empresa_id: string]: boolean};
type IConfiguraciones = {[id_infoconfiguracion in IConfiguracionesNameType]: IConfiguracionesType};
type IConfiguracionesById = {[id_infoconfiguracion in IConfiguracionesNameType]: number};
@Injectable({
  providedIn: 'root'
})
export class ConfiguracionService {

  private configuraciones: IConfiguraciones = {
    comerciaActivo: {},
    sociedades: {},
    entidadesSistemaSalud: {},
    crossSelling: {},
    AccesoCopiaSeguridad: {},
  };
  private readonly configuracionesById: IConfiguracionesById = {
    'comerciaActivo' : 577,
    'sociedades' : 319,
    'entidadesSistemaSalud' : 588,
    'crossSelling' : 599,
    'AccesoCopiaSeguridad' : 638,
  }
  private readonly oldComerciaActivo: {[empresa_id: string]: boolean} = {};

  constructor(private readonly storageService: StorageService, private readonly generalApi: GeneralApiService) {}
  async configuracionesByName(id_infoconfiguracion: IConfiguracionesNameType) {
    const actualEmpresaId = this.storageService.getEmpresaID();
    if (!actualEmpresaId) return false;
    const configuracion = this.configuraciones[id_infoconfiguracion];
    const configuracionId = this.configuracionesById[id_infoconfiguracion];
    if(configuracion[actualEmpresaId] !== undefined) return configuracion[actualEmpresaId];
    const result = await this.getConfiguracionById(configuracionId);
    this.configuraciones[id_infoconfiguracion][actualEmpresaId] = result;
    return result;
  }
  clearConfiguraciones() {
    this.configuraciones = {
      comerciaActivo: {},
      sociedades: {},
      entidadesSistemaSalud: {},
      crossSelling: {},
      AccesoCopiaSeguridad: {},
    };
  }
  resetConfiguracionesByName(id_infoconfiguracion: IConfiguracionesNameType) {
    delete this.configuraciones[id_infoconfiguracion][this.storageService.getEmpresaID()];
  }
  getConfiguracionById(id_infoconfiguracion: number, loading?: StatusApi) {
    const empresa_id = this.storageService.getEmpresaID();
    if (!empresa_id) return Promise.resolve(false);
    return this.generalApi.callApi<ValorPermiso>('post', `/empresa/${empresa_id}/infoconfiguracion/value`, {
      postData: {
        id_infoconfiguracion,
      },
      loading,
      oldApi: true,
      keyResult: 'value'
    })
    .then(valor => valor === 'T' || valor === 'S')
  }
  async getAccesoSociedades() {
    return this.configuracionesByName('sociedades');
  }
}
